import { render, staticRenderFns } from "./memberRegister.vue?vue&type=template&id=64b32b18&"
import script from "./memberRegister.vue?vue&type=script&lang=js&"
export * from "./memberRegister.vue?vue&type=script&lang=js&"
import style0 from "./memberRegister.vue?vue&type=style&index=0&id=64b32b18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports